import { styled } from "@mui/material/styles";
import { List, ListItem, ListItemButton } from "@mui/material";
import { Link } from "react-router-dom";

export const StyledList = styled(List)({
  minWidth: 200,
});

export const StyledListItem = styled(ListItem)({
  paddingTop: 0,
  paddingBottom: 0,
});

export const StyledListItemButton = styled(ListItemButton)({
  paddingTop: 0,
  paddingBottom: 0,
  "&:hover": {
    backgroundColor: "transparent",
  },
});

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.text.main,
  "&:hover": {
    color: theme.palette.primary.main,
    fontWeight: 600,
    "&::after": {
      display: "block",
      position: "absolute",
      content: "''",
      background: theme.palette.primary.main,
      bottom: "0px",
      width: "calc(100% - 20px)",
      height: "2px",
    },
  },
}));
